import React from "react";
import MediaQuery from "react-responsive";
import moment from "moment";

var OrderCard = function OrderCard(props) {
  var item = props.item,
      _props$viewDetailsAct = props.viewDetailsAction,
      viewDetailsAction = _props$viewDetailsAct === void 0 ? function () {
    return "";
  } : _props$viewDetailsAct,
      viewDetailsActionCopy = props.viewDetailsActionCopy,
      _props$orderAgainActi = props.orderAgainAction,
      orderAgainAction = _props$orderAgainActi === void 0 ? function () {
    return "";
  } : _props$orderAgainActi,
      orderAgainActionCopy = props.orderAgainActionCopy;
  var FormatedDate = moment(item.OrderDate).format("dddd, MMMM D, YYYY");
  var title = FormatedDate;
  var mobileTitle = FormatedDate;
  var orderNumber = "$".concat(item.Price.Total, " | Order # ").concat(item.OrderNumber, " | ").concat(item.Status);
  var items = item.CartLines || item.Items || [];
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-account-card",
    onClick: function onClick(e) {
      if (typeof viewDetailsAction === "undefined") {
        return false;
      }

      return viewDetailsAction();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-account-card__header"
  }, /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: 990
  }, /*#__PURE__*/React.createElement("h3", null, mobileTitle)), /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: 991
  }, /*#__PURE__*/React.createElement("h3", null, title))), /*#__PURE__*/React.createElement("div", {
    className: "cb-account-order"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "cb-account-order__title"
  }, orderNumber)));
};

export default OrderCard;